import { Doc } from '../../../types';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { buildHeadersFromDocumentParams } from '../logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../types/DocumentParams';

export const postDocumentFile = async (
  constructPost: ConstructPost,
  documentId: string,
  documentParams: DocumentParams,
  file: File,
): Promise<NonPaginatedResponse<Doc> | undefined> => {
  const formData = new FormData();
  formData.append('file', file);

  return constructPost(
    `${DOCUMENTS_BASE_PATH}/${documentId}/file`,
    { data: formData, headers: buildHeadersFromDocumentParams(documentParams) },
    { preventDefaultErrorToast: true },
  );
};
